import type { ReactNode } from "react";
import React from "react";
import type { DropdownOption } from "./Dropdown.js";
import { Dropdown } from "./Dropdown.js";
import { Label } from "../../ui/Label.js";
import { cn } from "@rosette/ts/src/util/cn.js";


interface DropdownAndLabelProps {
    children: ReactNode;
    className?: string;
    id: string;
    name?: string;
    value: string;
    setValue: (value: string) => void;
    options: DropdownOption[];
    tooltip?: (value: string) => (string | undefined);
    disabled?: boolean;
    noMargins?: boolean;
}


export function DropdownAndLabel({
    children, className, id, name, value,
    setValue, options, tooltip, disabled, noMargins,
}: DropdownAndLabelProps) {
    const tooltipText = (tooltip ? tooltip(value) : undefined);
    return (
        <div className={cn(
            noMargins ? null : "my-4",
            className ?? null,
        )}>
            <Label
                className={cn(
                    "mt-0 mr-3 mb-2",
                    disabled ? "cursor-auto text-subtle" : "cursor-pointer",
                )}
                htmlFor={id}>

                {children}
            </Label>
            <Dropdown
                className="w-auto min-w-[8em]"
                id={id}
                name={name}
                value={value}
                setValue={setValue}
                options={options}
                disabled={disabled}
                tooltipText={tooltipText} />
        </div>
    );
}
